export const interactionBudgets = {
  "shell-render": 100,
  "task-panel-open": 150,
  "task-filter": 100,
  "task-mutation": 150,
  "local-first-render": 500,
} as const;

export type MeasuredInteraction = keyof typeof interactionBudgets;

export function measureInteraction(name: MeasuredInteraction, startedAt: number, finishedAt = performance.now()): number {
  const duration = finishedAt - startedAt;
  performance.measure(`weirdo:${name}`, { start: startedAt, end: finishedAt, detail: { budget: interactionBudgets[name] } });
  if (duration > interactionBudgets[name]) console.warn(`[performance] ${name} took ${Math.round(duration)}ms (budget ${interactionBudgets[name]}ms)`);
  window.dispatchEvent(new CustomEvent("weirdo-performance", { detail: { name, duration, budget: interactionBudgets[name] } }));
  return duration;
}

export function observeLongTasks(): () => void {
  if (!("PerformanceObserver" in window) || !PerformanceObserver.supportedEntryTypes?.includes("longtask")) return () => undefined;
  const observer = new PerformanceObserver(entries => entries.getEntries().forEach(entry => console.warn(`[performance] long task blocked the UI for ${Math.round(entry.duration)}ms`)));
  observer.observe({ type: "longtask", buffered: true });
  return () => observer.disconnect();
}
